export const PRIVACY_REQUEST_TYPES = Object.freeze({
  MARKETING_OPT_OUT: "privacy_marketing_opt_out",
  DATA_OBJECTION: "privacy_data_objection",
});

export function isPrivacyRequestType(value) {
  return Object.values(PRIVACY_REQUEST_TYPES).includes(value);
}

export function getPrivacyRequestCopy(locale, requestType) {
  const en = locale === "en";
  const marketing = requestType === PRIVACY_REQUEST_TYPES.MARKETING_OPT_OUT;
  return {
    title: marketing
      ? (en ? "Stop marketing messages" : "Pazarlama iletilerini durdur")
      : (en ? "Object to personal data processing" : "Kişisel veri işlenmesine itiraz et"),
    description: marketing
      ? (en ? "Enter the email address for which you want to stop receiving marketing messages."
        : "Pazarlama iletilerini durdurmak istediğiniz e-posta adresini yazın.")
      : (en ? "Enter your email address to send Palmate your objection to the collection and processing of your personal data."
        : "Kişisel verilerinizin toplanmasına ve işlenmesine itirazınızı Palmate’e iletmek için e-posta adresinizi yazın."),
    details: en ? "Additional information (optional)" : "Açıklama (isteğe bağlı)",
    notice: en ? "We will use the information you provide to handle this request."
      : "Paylaştığınız bilgileri bu talebi değerlendirmek için kullanacağız.",
    submit: en ? "Send request" : "Talebi gönder",
    success: en ? "Your request has been received. Our team will review it and contact you about the outcome."
      : "Talebiniz alındı. Ekibimiz talebinizi değerlendirecek ve sonuç hakkında sizinle iletişime geçecek.",
  };
}

export function buildPrivacyRequestPayload(requestType, locale, details = "") {
  if (!isPrivacyRequestType(requestType)) return null;
  const copy = getPrivacyRequestCopy(locale, requestType);
  const note = typeof details === "string" ? details.trim().slice(0, 2500) : "";
  return {
    source: "privacy-policy",
    category: "privacy",
    privacy_request_type: requestType,
    request_status: "pending_review",
    locale: locale === "en" ? "en" : "tr",
    message: [
      `Privacy request: ${copy.title}`,
      "Status: Pending review / İnceleme bekliyor",
      requestType === PRIVACY_REQUEST_TYPES.MARKETING_OPT_OUT
        ? "Request: Stop marketing communications to the submitted email address."
        : "Request: Objection to the collection and processing of personal data.",
      ...(note ? [`Details: ${note}`] : []),
    ].join("\n"),
    details: note || null,
  };
}
